import reportService from "../shared/services/reportService";
import { CANCEL_MESSAGE } from "../shared/services/cancelRequest.service";
import { setLogout } from "./authActions";
import { getUnitReportView, getPivotData } from "../shared/services/positions.data.service";
import { buildChartData } from "./../components/Charts/chartDataService";
import TypesReport from "../components/sections/reports/static.reportsTypes";

const REQUEST_UNIT_REPORT = "REQUEST_UNIT_REPORT";
const RESPONSE_UNIT_REPORT = "RESPONSE_UNIT_REPORT";
const REQUEST_UNIT_REPORT_FAILURE = "REQUEST_UNIT_REPORT_FAILURE";
const RESPONSE_CANCEL_UNIT_REPORT = "RESPONSE_CANCEL_UNIT_REPORT";
const CLEAR_UNIT_REPORT = "CLEAR_UNIT_REPORT";

const requestUnitReportAction = () => {
  return {
    type: REQUEST_UNIT_REPORT,
  };
};

const reponseUnitReportAction = (data) => {
  return {
    type: RESPONSE_UNIT_REPORT,
    data,
  };
};

const requestUnitReportFailureAction = (errors) => {
  return {
    type: REQUEST_UNIT_REPORT_FAILURE,
    errors,
  };
};

const responseCancelUnitReportAction = () => {
  return {
    type: RESPONSE_CANCEL_UNIT_REPORT,
  };
};

const getUnitsReport = (id, options, cancelToken, report) => {
  return (dispatch) => {
    dispatch(requestUnitReportAction());

    reportService
      .getUnitsReport(id, options, cancelToken)
      .then((result) => {
        const reportView = {
          reportData: result.data,
          pivot: getPivotData(report.fields, result.data.pivot),
          units: result.data.units.map((x) => {
            if (report.reportType !== TypesReport.chart.type) {
              return getUnitReportView(x, report);
            } else {
              return {
                info: x.info,
                information: x.dashboard,
                data: report,
                tableData: buildChartData(result.data, report, x.info.id),
              };
            }
          }),
        };

        dispatch(reponseUnitReportAction(reportView));
      })
      .catch((error) => {
        dispatch(requestUnitReportFailureAction(error.response));

        /*   if (error.message === CANCEL_MESSAGE) {
          dispatch(responseCancelUnitReportAction());
        } else {
          dispatch(requestUnitReportFailureAction(error.response));
        } */

        if (error.response && error.response.status === 401) {
          dispatch(setLogout());
        }
      });
  };
};

const clearUnitReportAction = () => {
  return {
    type: CLEAR_UNIT_REPORT,
  };
};

const clearUnitReport = () => {
  return (dispatch) => {
    dispatch(clearUnitReportAction());
  };
};

export {
  REQUEST_UNIT_REPORT,
  RESPONSE_UNIT_REPORT,
  REQUEST_UNIT_REPORT_FAILURE,
  RESPONSE_CANCEL_UNIT_REPORT,
  CLEAR_UNIT_REPORT,
  requestUnitReportAction,
  reponseUnitReportAction,
  requestUnitReportFailureAction,
  getUnitsReport,
  responseCancelUnitReportAction,
  clearUnitReportAction,
  clearUnitReport,
};
